import axios from 'axios'

const config = {
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    }
}

const categorie = {
    state: {
        list: []
    },
    mutations: {
        SET_CATEGORIES_LIST(state, payload) {
            state.list = payload
        },
    },
    actions: {
        fetchCategories: async ({
            commit
        }) => {

            try {
                const {
                    data
                } = await axios.get(`${process.env.VUE_APP_API}/categories/fetch`, config)

                commit('SET_CATEGORIES_LIST', data)

                console.info(data)
                return {
                    status: 200,
                    data
                }
            } catch (error) {

                console.error(error)
                return {
                    status: 500,
                    error
                }
            }

        },

        async insertCategory({
            dispatch
        }, payload) {
            try {

                await axios.post(`${process.env.VUE_APP_API}/categories/insert`, payload, config)
                await dispatch('fetchCategories')

                return true

            } catch (error) {
                throw error
            }
        },

        async editCategory({
                dispatch
            },
            payload) {
            try {

                await axios.post(`${process.env.VUE_APP_API}/categories/edit`, payload, config)
                await dispatch('fetchCategories')

                return true

            } catch (error) {
                throw error
            }
        },

        async deleteCategory({
                dispatch
            },
            payload) {
            try {

                await axios.post(`${process.env.VUE_APP_API}/categories/delete`, payload, config)
                await dispatch('fetchCategories')

                return true

            } catch (error) {
                throw error
            }
        },
    },
    getters: {
        getCategoriesList: state => state.list,
    }
}

export default categorie